<template>
  <div class="listing-search-cancel">
    <button
      v-if="offered"
      ref="button"
      type="button"
      class="button listing-search-cancel__button"
      @click="listingSearch.cancel()"
    >
      Cancelar busca
    </button>
  </div>
</template>

<script>
import { LISTING_SEARCH } from '@/composables/useListingSearch';

export default {
  name: 'ListingSearchCancel',
  inject: {
    listingSearch: { from: LISTING_SEARCH, default: null },
  },
  computed: {
    offered() {
      return Boolean(this.listingSearch?.cancelOffered);
    },
  },
  watch: {
    offered(isOffered) {
      if (isOffered) {
        document.addEventListener('keydown', this.cancelOnEscape);
        this.$nextTick(() => this.$refs.button?.focus());
        return;
      }

      document.removeEventListener('keydown', this.cancelOnEscape);
      if (this.$refs.button === document.activeElement) this.$emit('withdrawn');
    },
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.cancelOnEscape);
  },
  methods: {
    cancelOnEscape(event) {
      if (event.key !== 'Escape' || event.defaultPrevented) return;
      this.listingSearch.cancel();
    },
  },
};
</script>

<style lang="scss" scoped>
.listing-search-cancel__button {
  position: fixed;
  top: calc(50% + 5rem);
  left: 50%;
  z-index: 1001;

  min-height: 44px;
  padding: 0 1.25rem;

  font-weight: 600;

  transform: translateX(-50%);
}
</style>
